import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=41ab0ff6&scoped=true&"
import script from "./Personnel.vue?vue&type=script&lang=ts&"
export * from "./Personnel.vue?vue&type=script&lang=ts&"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=41ab0ff6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ab0ff6",
  null
  
)

export default component.exports